document.documentElement.classList.remove('no-js');
/* red de seguridad: si el IntersectionObserver no dispara en 2,5 s, todo .reveal se muestra igual */
setTimeout(function(){ try{ document.querySelectorAll('.reveal:not(.in)').forEach(function(e){ e.classList.add('in'); }); }catch(e){ document.documentElement.classList.add('pk-js-failed'); } }, 2500);
window.addEventListener('error', function(){ document.documentElement.classList.add('pk-js-failed'); });

/* ============ DATOS (inyectados por Liquid) ============ */
var PRODUCT = window.PK_PRODUCT || {};
PRODUCT.locale = PRODUCT.locale || 'es-CL';
function esc(s){ return String(s==null?"":s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;"); }

/* ============ CART DRAWER ============ */
function cartMoney(cents){
  var cur = PRODUCT.currency_iso || 'CLP';
  try{ return new Intl.NumberFormat(PRODUCT.locale, {style:'currency', currency:cur}).format(cents/100); }
  catch(e){ return '$' + Math.round(cents/100); }
}
var _cartCdStarted=false;
function cartEtaText(){
  var loc=PRODUCT.locale, o={day:"numeric",month:"short"};
  var a=new Date(); a.setDate(a.getDate()+2); var b=new Date(); b.setDate(b.getDate()+4);
  try{ return a.toLocaleDateString(loc,o)+" – "+b.toLocaleDateString(loc,o); }catch(e){ return ""; }
}
function startCartCd(){
  if(_cartCdStarted) return; var el=document.getElementById("cartCd"); if(!el) return; _cartCdStarted=true;
  var end=Date.now()+10*60*1000;
  (function t(){ var d=Math.max(0,end-Date.now()); var m=Math.floor(d/60000), s=Math.floor(d%60000/1000);
    el.textContent=(m<10?"0":"")+m+":"+(s<10?"0":"")+s; if(d>0) setTimeout(t,1000); })();
}
function cartOpen(){ var d=document.getElementById("cartDr"), o=document.getElementById("cartOv"); if(d)d.classList.add("open"); if(o)o.classList.add("open"); document.body.style.overflow="hidden";
  var e=document.getElementById("cartEta"); if(e) e.textContent=cartEtaText(); startCartCd(); cartLoad(); }
function cartClose(){ var d=document.getElementById("cartDr"), o=document.getElementById("cartOv"); if(d)d.classList.remove("open"); if(o)o.classList.remove("open"); document.body.style.overflow=""; }
function cartLoad(){
  fetch("/cart.js").then(function(r){return r.json();}).then(function(c){
    var cnt=document.getElementById("cartCount"); if(cnt){ cnt.textContent=c.item_count; cnt.style.display=c.item_count?"":"none"; }
    var hn=document.getElementById("cartHN"); if(hn) hn.textContent="("+c.item_count+")";
    var tot=document.getElementById("cartTotal"); if(tot) tot.textContent=cartMoney(c.total_price);
    var body=document.getElementById("cartItems"), dr=document.getElementById("cartDr"); if(!body) return;
    if(!c.items.length){ body.innerHTML='<div class="cart-empty">'+esc(dr?dr.getAttribute("data-empty"):"")+'</div>'; return; }
    var trash='<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/></svg>';
    body.innerHTML=c.items.map(function(it){
      var img=it.image?(it.image+(it.image.indexOf('?')<0?'?':'&')+'width=120'):"";
      return '<div class="citem"><img src="'+esc(img)+'" alt=""><div class="ci-info"><b>'+esc(it.product_title)+'</b>'+
        '<span>'+esc(it.variant_title&&it.variant_title!=="Default Title"?it.variant_title:"")+'</span>'+
        '<div class="ci-q"><button onclick="cartQty(\''+it.key+'\','+(it.quantity-1)+')">-</button><span>'+it.quantity+'</span>'+
        '<button onclick="cartQty(\''+it.key+'\','+(it.quantity+1)+')">+</button></div></div>'+
        '<div class="ci-r"><button class="ci-trash" title="Quitar" aria-label="quitar" onclick="cartQty(\''+it.key+'\',0)">'+trash+'</button>'+
        '<div class="ci-p">'+cartMoney(it.final_line_price)+'</div></div></div>';
    }).join("");
  }).catch(function(){});
}
function cartQty(key, q){
  fetch("/cart/change.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({id:key,quantity:Math.max(0,q)})})
   .then(function(r){return r.json();}).then(function(){ cartLoad(); }).catch(function(){});
}
function cartCheckout(){ window.location.href="/checkout"; }
cartLoad();
window.addEventListener("pageshow", function(e){ if(e && e.persisted){ try{ cartLoad(); }catch(_e){} } });
if((location.hash==="#cart")||/[?&]cart=1(&|$)/.test(location.search)){ setTimeout(cartOpen,180); }

/* ============ CTA de oferta: lleva al selector de packs / botón de compra ============ */
function scrollBundles(e){ if(e) e.preventDefault();
  var b=document.getElementById("pkBundleHost");
  if(b) b.scrollIntoView({behavior:"smooth",block:"center"}); }

/* ============ SELECTOR DE PACKS (widget reconstruido) ============ */
window.PK_SELECTED_IDX = window.PK_SELECTED_IDX|0;
function pkSelectPack(i){
  var cards=document.querySelectorAll('#pkPacks .pkb-card'); if(!cards.length) return;
  i=Math.max(0,Math.min(cards.length-1,i|0));
  for(var k=0;k<cards.length;k++){
    var on=(k===i);
    if(cards[k].classList.contains('on')!==on) cards[k].classList.toggle('on', on);
    var r=cards[k].querySelector('input'); if(r && r.checked!==on) r.checked=on;
  }
  window.PK_SELECTED_IDX=i;
  var q=document.querySelector('[data-pk-qty]'); if(q && q.value!==String(i+1)) q.value=String(i+1);
  pkStickyPrice();
}
window.pkSelectPack=pkSelectPack;
function pkStickyPrice(){
  var sp=document.getElementById("stPrice"); if(!sp) return;
  var c=document.querySelectorAll('#pkPacks .pkb-card')[window.PK_SELECTED_IDX|0]; if(!c) return;
  var now=c.getAttribute('data-price')||'', was=c.getAttribute('data-was')||'';
  var html=esc(now)+(was?' <span class="w">'+esc(was)+'</span>':'');
  if(sp.innerHTML!==html) sp.innerHTML=html;
}
pkStickyPrice();

/* temporizador y "personas comprando" de la barra de oferta */
(function(){
  var el=document.getElementById("pkTimer"); if(el){
    var end=Date.now()+(parseInt(el.getAttribute("data-min"),10)||15)*60*1000;
    (function tick(){ var d=Math.max(0,end-Date.now()); var m=Math.floor(d/60000), s=Math.floor(d%60000/1000);
      var t=(m<10?"0":"")+m+":"+(s<10?"0":"")+s; if(el.textContent!==t) el.textContent=t; if(d>0) setTimeout(tick,1000); })();
  }
  var b=document.getElementById("pkBuyers"); if(b){ var n=parseInt(b.textContent,10)||16;
    setInterval(function(){ n+=Math.floor(Math.random()*5)-2; if(n<6)n=6; if(n>40)n=40; b.textContent=n; }, 4000); }
})();

/* ============ BOTÓN COD (Releasit): se viste como el botón de la fuente ============ */
var RSI_BTN = '._rsi-buy-now-button, #rsi_buy_now_button:not(.rsi_floating)';
(function(){
  var host = document.getElementById('pkReleasitHost'); if (!host) return;
  var root = host.closest('[data-cta-bg]') || host, d = root.dataset;
  var S = { 'background': d.ctaBg, 'background-color': d.ctaBg, 'color': d.ctaColor, 'border-radius': d.ctaRadius, 'border': '0',
            'box-shadow': d.ctaShadow || 'none', 'font-size': d.ctaSize || '15px', 'font-weight': d.ctaWeight || '700',
            'font-family': 'inherit', 'padding': d.ctaPadding || '14px 24px', 'width': '100%', 'margin': '8px 0',
            'text-transform': 'none', 'letter-spacing': 'normal', 'animation': 'none' };
  var mo = null, runs = 0, win = 0, OBS = { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] };
  function dress(){
    var now = Date.now(); if (now - win > 10000) { win = now; runs = 0; }
    if (++runs > 25) { if (mo) { mo.disconnect(); mo = null; } return; }
    if (mo) mo.disconnect();
    try {
      host.querySelectorAll(RSI_BTN).forEach(function(b){
        if (b.classList.contains('_rsi-buy-now-button-product-floating')) return;
        for (var k in S) { if (S[k] && b.style.getPropertyValue(k) !== S[k]) b.style.setProperty(k, S[k], 'important'); }
        if (b.classList.contains('_rsi-buy-now-button-shaker')) b.classList.remove('_rsi-buy-now-button-shaker');
        if (b.classList.contains('rsi_animation_shake')) b.classList.remove('rsi_animation_shake');
        if (!b.classList.contains('pkb-shine')) b.classList.add('pkb-shine');
        var svg = b.querySelector('svg'); if (svg && svg.getAttribute('fill') && svg.getAttribute('fill') !== 'none' && svg.getAttribute('fill') !== S.color) svg.setAttribute('fill', S.color);
        b.querySelectorAll('span').forEach(function(sp){ if (sp.style.getPropertyValue('color') !== S.color) sp.style.setProperty('color', S.color, 'important'); });
      });
    } catch (e) {}
    if (mo) { try { mo.observe(host, OBS); } catch (e) {} }
  }
  if (window.MutationObserver) { mo = new MutationObserver(dress); }
  dress();
  if (mo) { try { mo.observe(host, OBS); } catch (e) {} }
  [300, 1000, 2500, 5000].forEach(function(ms){ setTimeout(dress, ms); }); window.addEventListener('load', dress);
})();

/* al abrir el formulario de la app se preselecciona la misma oferta (por índice) */
var RSI_MODAL = '#_rsi-cod-form-modal._rsi-cod-form-modal-open, dialog#rsi_form_wrapper[open]', RSI_OFFER = '._rsi-quantity-offers-offer-container', RSI_SEL = '_rsi-quantity-offers-selected';
var pkSyncing = false;
function syncReleasit(){
  if (!document.getElementById('pkPacks')) return;
  if (pkSyncing) return; pkSyncing = true;
  var t0 = Date.now(), done = false, mo = null, clicks = 0, last = 0;
  function finish(){ done = true; pkSyncing = false; if (mo) { mo.disconnect(); mo = null; } }
  function apply(){
    if (done) return true;
    if (!document.querySelector(RSI_MODAL)) return false;
    var offers = document.querySelectorAll(RSI_OFFER); if (!offers.length) return false;
    var el = offers[window.PK_SELECTED_IDX | 0]; if (!el) { finish(); return true; }
    if (el.classList.contains(RSI_SEL) || el.querySelector('.' + RSI_SEL)) { finish(); return true; }
    var target = el.querySelector('._rsi-quantity-offers-offer') || el;
    if (clicks < 6 && Date.now() - last > 250) { clicks++; last = Date.now(); try { target.click(); } catch (e) {} }
    return false;
  }
  if (apply()) return;
  if (window.MutationObserver) { mo = new MutationObserver(function(){ if (apply()) return; if (Date.now() - t0 > 6000) finish(); });
    mo.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] }); }
  (function poll(){ if (done) return; if (apply()) return; if (Date.now() - t0 > 6000) { finish(); return; } setTimeout(poll, 150); })();
}
document.addEventListener('click', function(e){
  var h = document.getElementById('pkReleasitHost'); if (!h || !e.target || !e.target.closest) return;
  var t = e.target.closest(RSI_BTN); if (t && h.contains(t)) syncReleasit();
}, true);
window.pkOpenReleasit = function(){ var b = document.getElementById('pkReleasitHost'); b = b && b.querySelector(RSI_BTN); if (!b) return false; b.click(); return true; };

/* ============ URGENCY countdown ============ */
(function(){
  var el=document.getElementById("cd"); if(!el) return;
  var end=Date.now()+ ((parseInt(el.getAttribute("data-min"),10)||15)*60-1)*1000;
  (function tick(){
    var d=Math.max(0,end-Date.now());
    var h=Math.floor(d/3600000), m=Math.floor(d%3600000/60000), s=Math.floor(d%60000/1000);
    el.textContent=(h<10?"0":"")+h+":"+(m<10?"0":"")+m+":"+(s<10?"0":"")+s;
    if(d>0) setTimeout(tick,1000);
  })();
})();

/* ============ STICKY on scroll (solo si se activa en el editor) ============ */
(function(){
  var cta=document.getElementById("pkBundleHost"), bar=document.getElementById("sticky"); if(!cta||!bar) return;
  window.addEventListener("scroll", function(){
    var on = cta.getBoundingClientRect().bottom < -10;
    if (bar.classList.contains("show") !== on) bar.classList.toggle("show", on);
  }, {passive:true});
})();

/* ============ SOCIAL PROOF TOAST ============ */
(function(){
  var el=document.getElementById("toast"); if(!el) return;
  if(!document.getElementById("toastFix")){ var _tf=document.createElement("style"); _tf.id="toastFix";
    _tf.textContent=".toast:not(.show){pointer-events:none}"; document.head.appendChild(_tf); }
  var data=window.PK_TOAST||[]; if(!data.length) return;
  var i=0;
  function show(){
    var d=data[i%data.length]; i++;
    document.getElementById("toastName").textContent=d.n;
    document.getElementById("toastTxt").textContent=" "+d.t;
    document.getElementById("toastAgo").textContent=d.a;
    el.classList.add("show");
    setTimeout(function(){ el.classList.remove("show"); }, 4500);
  }
  setTimeout(function(){ show(); setInterval(show, 9000); }, 3500);
})();

/* ============ COUNT-UP (escribe en el nodo de texto, solo si cambió) ============ */
(function(){
  var els=document.querySelectorAll("[data-count]"); if(!els.length) return;
  function put(el, v){ var s=v.toLocaleString(), n=el.firstChild; if(n && n.nodeType===3 && !n.nextSibling){ if(n.nodeValue!==s) n.nodeValue=s; } else el.textContent=s; }
  function run(el){
    var to=parseFloat(el.getAttribute("data-count")), dur=1200, t0=null;
    if(isNaN(to)) return;
    function step(ts){ if(!t0)t0=ts; var p=Math.min(1,(ts-t0)/dur);
      put(el, Math.floor(to*(1-Math.pow(1-p,3)))); if(p<1)requestAnimationFrame(step); }
    requestAnimationFrame(step);
  }
  if(!("IntersectionObserver" in window)){ els.forEach(run); return; }
  var io=new IntersectionObserver(function(en){en.forEach(function(e){if(e.isIntersecting){run(e.target);io.unobserve(e.target);}});},{threshold:.5});
  els.forEach(function(e){io.observe(e);});
})();

/* ============ GALLERY (carrusel scroll-snap: swipe móvil) ============ */
var GAL_I = 0;
function galCount(){ return document.querySelectorAll("#galTrack .galslide").length; }
function galShow(i){
  var track=document.getElementById("galTrack"); if(!track) return;
  var n=galCount(); GAL_I=Math.max(0, Math.min(n-1, i));
  track.scrollTo({left: GAL_I*track.clientWidth, behavior:"smooth"});
  galSync();
}
function galSync(){
  var track=document.getElementById("galTrack"); if(!track) return;
  var n=galCount(); if(!n) return;
  GAL_I=Math.round(track.scrollLeft/Math.max(1,track.clientWidth));
  var thumbs=document.querySelectorAll("#galThumbs img");
  thumbs.forEach(function(x,k){ var on=(k===GAL_I); if(x.classList.contains("on")!==on) x.classList.toggle("on", on); });
  var tw=document.getElementById("galThumbs"), on=thumbs[GAL_I];
  if(tw && on){ var sl=on.offsetLeft - (tw.clientWidth - on.clientWidth)/2; if(Math.abs(tw.scrollLeft-sl)>1) tw.scrollLeft = sl; }
  var pv=document.querySelector(".galnav.prev"), nx=document.querySelector(".galnav.next");
  if(pv){ var a=GAL_I<=0 ? "none" : ""; if(pv.style.display!==a) pv.style.display=a; }
  if(nx){ var b=GAL_I>=n-1 ? "none" : ""; if(nx.style.display!==b) nx.style.display=b; }
}
function galArrow(d){ galShow(GAL_I+d); }
function bmenuToggle(){ var h=document.querySelector(".bhead"); if(h) h.classList.toggle("open"); }
function bmenuClose(){ var h=document.querySelector(".bhead"); if(h) h.classList.remove("open"); }
(function(){
  var track=document.getElementById("galTrack"); if(!track) return;
  var to; track.addEventListener("scroll", function(){ clearTimeout(to); to=setTimeout(galSync,60); }, {passive:true});
  var t=document.getElementById("galThumbs");
  if(t) t.addEventListener("click", function(e){ var img=e.target.closest("img"); if(!img) return; galShow(+img.getAttribute("data-i")); });
  var lw=window.innerWidth; window.addEventListener("resize", function(){ if(window.innerWidth===lw) return; lw=window.innerWidth; galShow(GAL_I); }, {passive:true});
  galSync();
})();

/* ============ STORIES (lightbox foto/video reseñas) ============ */
var STORY_ELS=[], STORY_I=0;
(function(){ if(document.getElementById("stvStyle")) return;
  var st=document.createElement("style"); st.id="stvStyle";
  st.textContent=
    ".storycap{background:linear-gradient(0deg,rgba(0,0,0,.9) 0%,rgba(0,0,0,.5) 58%,transparent 100%)!important;padding:26px 18px 14px!important}"
   +"#storyText{position:relative;margin:6px 0 0;font-size:13.5px;line-height:1.62;color:rgba(255,255,255,.95);max-height:7.4em;overflow:hidden}"
   +"#storyText.stroll{-webkit-mask-image:linear-gradient(180deg,transparent 0,#000 24%,#000 100%);mask-image:linear-gradient(180deg,transparent 0,#000 24%,#000 100%)}"
   +"#storyText .stseg{display:block;padding-bottom:1.35em}"
   +"#storyText.stroll .stseg{animation:stvup var(--stdur,22s) linear infinite}"
   +".storycap:hover .stseg,.storycap:active .stseg{animation-play-state:paused}"
   +"@keyframes stvup{from{transform:translateY(0)}to{transform:translateY(-100%)}}";
  document.head.appendChild(st);
})();
function storyRender(){
  if(!STORY_ELS.length) return;
  STORY_I=(STORY_I%STORY_ELS.length+STORY_ELS.length)%STORY_ELS.length;
  var el=STORY_ELS[STORY_I], img=el.getAttribute("data-img"), vid=el.getAttribute("data-video");
  var m=document.getElementById("storyMedia"); if(!m) return;
  m.innerHTML = vid ? ('<video src="'+esc(vid)+'" autoplay muted loop playsinline controls></video>') : ('<img src="'+esc(img)+'" alt="">');
  var nm=document.getElementById("storyName"); if(nm) nm.textContent=el.getAttribute("data-name")||"";
  var tx=document.getElementById("storyText");
  if(tx){
    var t=el.getAttribute("data-text")||"";
    tx.classList.remove("stroll"); tx.innerHTML="";
    var s1=document.createElement("span"); s1.className="stseg"; s1.textContent=t; tx.appendChild(s1);
    requestAnimationFrame(function(){
      if(s1.offsetHeight>tx.clientHeight+6){
        var s2=document.createElement("span"); s2.className="stseg"; s2.textContent=t; tx.appendChild(s2);
        tx.style.setProperty("--stdur", Math.max(16, Math.round(s1.offsetHeight/13))+"s");
        tx.classList.add("stroll");
      }
    });
  }
  document.querySelectorAll(".story").forEach(function(x){x.classList.remove("seen");}); el.classList.add("seen");
}
function storyOpen(btn){
  STORY_ELS=Array.prototype.slice.call(btn.parentNode.querySelectorAll(".story"));
  STORY_I=STORY_ELS.indexOf(btn);
  var mo=document.getElementById("storyModal"), ov=document.getElementById("storyOv");
  if(mo)mo.classList.add("open"); if(ov)ov.classList.add("open"); document.body.style.overflow="hidden"; storyRender();
}
function storyClose(){ var mo=document.getElementById("storyModal"), ov=document.getElementById("storyOv");
  if(mo)mo.classList.remove("open"); if(ov)ov.classList.remove("open"); document.body.style.overflow="";
  var m=document.getElementById("storyMedia"); if(m)m.innerHTML=""; }
function storyStep(d){ STORY_I+=d; storyRender(); }

/* ============ FAQ ============ */
document.querySelectorAll(".qa .q").forEach(function(q){
  q.addEventListener("click", function(){
    var qa=q.parentNode, a=qa.querySelector(".a"), open=qa.classList.contains("open");
    document.querySelectorAll(".qa").forEach(function(x){ x.classList.remove("open"); x.querySelector(".a").style.maxHeight=null; });
    if(!open){ qa.classList.add("open"); a.style.maxHeight=a.scrollHeight+"px"; }
  });
});

/* ============ MARQUEE ============ */
(function(){ var t=document.getElementById("mqTrack"); if(t) t.innerHTML += t.innerHTML; })();

/* ============ MARQUEE RESEÑAS (scroll infinito) ============ */
(function(){ var t=document.getElementById("ugcTrack"); if(!t) return;
  var n=t.children.length; if(n<1) return;
  t.innerHTML += t.innerHTML;
  t.setAttribute("data-dup","1");
  var mq=t.parentElement; if(mq){ mq.style.setProperty("--ugcdur", Math.max(28, n*7)+"s"); mq.style.overflow="hidden"; }
})();

/* ============ VIEWERS fluctuation ============ */
(function(){ var el=document.getElementById("vwN"); if(!el) return;
  var n=parseInt(el.textContent,10)||27;
  setInterval(function(){ n+=Math.floor(Math.random()*7)-3; if(n<11)n=11; if(n>58)n=58; el.textContent=n; }, 3500);
})();

/* ============ TIMELINE fechas dinámicas ============ */
(function(){
  var loc=PRODUCT.locale, opt={day:"numeric",month:"short"};
  for(var i=0;i<3;i++){ var el=document.getElementById("tlDate"+i); if(!el) continue;
    var d=new Date(); d.setDate(d.getDate()+i); try{el.textContent=d.toLocaleDateString(loc,opt);}catch(e){el.textContent=(d.getDate())+"/"+(d.getMonth()+1);} }
})();
(function(){ var el=document.getElementById("soldN"); if(!el) return; var n=parseInt(el.textContent,10)||34;
  setInterval(function(){ n+=Math.floor(Math.random()*3); if(n>240)n=34; el.textContent=n; }, 8000); })();

/* ============ SCROLL REVEAL ============ */
(function(){
  var els=document.querySelectorAll(".reveal");
  if(!("IntersectionObserver" in window)){ els.forEach(function(e){e.classList.add("in");}); return; }
  var io=new IntersectionObserver(function(ents){ents.forEach(function(en){if(en.isIntersecting){en.target.classList.add("in");io.unobserve(en.target);}});},{threshold:.12});
  els.forEach(function(e){io.observe(e);});
})();
